export default __webpack_public_path__ + "static/media/notification.b65b1a87.mp3";